import Login from './views/Login.vue'
import NotFound from './views/404.vue'
import Home from './views/Home.vue'
import RouteView from './views/RouteView.vue'
import Main from './views/Main.vue'
import Main2 from './views/Main2.vue'
import MainIndex from './views/MainIndex.vue'
import fuwu from './views/fuwu.vue'
import fankui from './views/fankui.vue'
import Customer from './views/Customer.vue'
import Material from './views/Material.vue'
import Car from './views/Car.vue'

import test from './views/charts/test.vue'
import xieyi from './views/xieyi.vue'


import GanxieArticleList from './views/ganxie/article/list.vue'
import GanxieArticClassList from './views/ganxie/class/list.vue'


//客服


//省级客服

//后台





//http://fontawesome.dashgame.com/
let routes = [
    {
        path: '/login',
        component: Login,
        name: '',
        hidden: true
    }, {
        path: '/',
        component: Login,
        name: '',
        hidden: true
    }, {
        path: '/test',
        component: test,
        name: '',
        hidden: true
    },
     {
            path: '/xieyi',
            component: xieyi,
            name: '',
            hidden: true
        },
    {
        path: '/mainIndex',
        component: Home,
        name: '首页',
        iconCls: 'fa fa-user-circle-o',//图标样式class
        children: [
            {path: '/mainIndex', component: MainIndex, name: '首页',leaf: true,
        iconCls: 'fa fa-user-circle-o',},
            {path: '/main', component: Main, name: '过磅记录',leaf: true,
        iconCls: 'fa fa-user-circle-o',},
            {path: '/main2', component: Main2, name: '预约称重',leaf: true,
        iconCls: 'fa fa-user-circle-o',},

            {path: '/fuwu', component: fuwu, name: '服务',leaf: true,
        iconCls: 'fa fa-user-circle-o',},
              {path: '/fankui', component: fankui, name: '意见反馈',leaf: true,
        iconCls: 'fa fa-user-circle-o',},
              {path: '/Customer', component: Customer, name: '客户列表',leaf: true,
        iconCls: 'fa fa-user-circle-o',},
              {path: '/Material', component: Material, name: '物资管理',leaf: true,
        iconCls: 'fa fa-user-circle-o',},
              {path: '/Car', component: Car, name: '车辆管理',leaf: true,
        iconCls: 'fa fa-user-circle-o',}

        ]
    },
         {
             path: '/xieyi',
             component: Home,
             name: '主页',
             iconCls: 'fa fa-user-circle-o',//图标样式class
             leaf: true,
             children: [
                 {path: '/xieyi', component: xieyi, name: '协议',leaf: true,},

     /*   {path: '/test', component: test, name: 'test'}*/
                  /* {path: '/form', component: Form, name: 'Form'},
                   {path: '/user2', component: user2, name: '列表'},*!/*/
             ]
         }
];
export const asyncRouterMap = [




    {
        path: 'transfer',
        component: Home,
        name: '感谢圈',
        iconCls: 'fa fa-money',
        leaf: false,//只有一个节点
        meta: {roles: [ 'ADMIN','OPERATION']},
        children: [
            {
                path: '/ganxie/admin-class/list',
                component: GanxieArticClassList,
                name: '文章分类',
                leaf: true,
                meta: {roles: ['OPERATION', 'ADMIN']}
            }, {
                path: '/ganxie/admin-article/list',
                component: GanxieArticleList,
                name: '文章管理',
                leaf: true,
                meta: {roles: ['OPERATION', 'ADMIN']}
            },

        ]
    },
    {
        path: 'transfer',
        component: Home,
        name: '后台管理',
        iconCls: 'fa fa-money',
        leaf: false,//只有一个节点
        meta: {roles: [ 'ADMIN']},
        children: [


        ]
    },



    {
        path: '*',
        hidden: true,
        redirect: {path: '/404'}
    }
];

export default routes;




// WEBPACK FOOTER //
// ./src/routes.js